"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NewsHighlights() {
  const {
    ref: headerRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const scrollerRef = useRef<HTMLDivElement | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const highlights = [{
    date: "25.05.2024",
    title: "LAPORAN UTAMA NASIONAL",
    description: "Liputan mendalam mengenai perkembangan kebijakan ekonomi terbaru di tingkat pusat.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/berita_nasional.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/berita_nasional.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/berita_nasional.png-wvc-sizes",
    alt: "Suasana rapat kabinet di istana negara"
  }, {
    date: "24.05.2024",
    title: "KLARIFIKASI RESMI",
    description: "Menanggapi isu yang beredar di media sosial terkait kebijakan publik terkini.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/klarifikasi_isu.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/klarifikasi_isu.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/klarifikasi_isu.png-wvc-sizes",
    alt: "Dokumen klarifikasi resmi dengan stempel"
  }, {
    date: "23.05.2024",
    title: "ZONA PEMUDA PANCASILA",
    description: "Aksi sosial kemanusiaan yang dilakukan oleh kader di berbagai wilayah.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/aksi_sosial.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/aksi_sosial.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/aksi_sosial.png-wvc-sizes",
    alt: "Kader organisasi sedang melakukan bakti sosial"
  }, {
    date: "22.05.2024",
    title: "LIVE STREAMING",
    description: "Liputan langsung dari lokasi kejadian peristiwa penting hari ini.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/liputan_live.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/liputan_live.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/liputan_live.png-wvc-sizes",
    alt: "Reporter sedang melakukan siaran langsung"
  }, {
    date: "21.05.2024",
    title: "KERJASAMA STRATEGIS",
    description: "Penandatanganan nota kesepahaman untuk pengembangan portal berita daerah.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/kerjasama_media.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/kerjasama_media.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/kerjasama_media.png-wvc-sizes",
    alt: "Dua pihak berjabat tangan setelah penandatanganan"
  }, {
    date: "20.05.2024",
    title: "OPINI PUBLIK",
    description: "Analisis tajam dari para pakar mengenai dinamika politik nasional.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/opini_pakar.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/opini_pakar.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/opini_pakar.webp-wvc-sizes",
    alt: "Pakar sedang memberikan analisis di studio"
  }];
  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const handleScroll = () => {
      const cards = scroller.querySelectorAll<HTMLElement>("[data-card]");
      if (!cards.length) return;
      const scrollerRect = scroller.getBoundingClientRect();
      let closestIndex = 0;
      let closestDistance = Infinity;
      cards.forEach((card, i) => {
        const rect = card.getBoundingClientRect();
        const distance = Math.abs(rect.left - scrollerRect.left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });
      setActiveIndex(closestIndex);
    };
    scroller.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => scroller.removeEventListener("scroll", handleScroll);
  }, []);
  const scrollToCard = (direction: "prev" | "next") => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const cards = scroller.querySelectorAll<HTMLElement>("[data-card]");
    if (!cards.length) return;
    const targetIndex = direction === "next" ? Math.min(activeIndex + 1, cards.length - 1) : Math.max(activeIndex - 1, 0);
    const target = cards[targetIndex];
    if (target) {
      scroller.scrollTo({
        left: target.offsetLeft,
        behavior: "smooth"
      });
    }
  };
  const totalCards = highlights.length;
  const counterCurrent = String(activeIndex + 1).padStart(2, "0");
  const counterTotal = String(totalCards).padStart(2, "0");
  const progressPercent = (activeIndex + 1) / totalCards * 100;
  return <section data-section-id="1640" id="categoryrolefilter" className="bg-white text-black relative py-24 md:py-36 overflow-hidden">
      <div aria-hidden="true" className="pointer-events-none absolute -top-8 right-4 md:right-16 select-none font-default font-bold leading-none opacity-[0.04]" style={{
      fontSize: "clamp(12rem, 28vw, 22rem)"
    }}>
        ABADI
      </div>

      <div ref={headerRef} className="relative mx-auto max-w-[1360px] px-[clamp(1rem,4vw,3rem)]">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-end">
          <div className={`md:col-span-7 transition-all duration-500 ease-[cubic-bezier(0.2,0.8,0.2,1)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
            <div className="flex items-center gap-3 mb-6">
              <span className="font-default text-xs font-semibold uppercase tracking-[0.18em] text-orange-600">
                ABADI.NEWS
              </span>
              <span aria-hidden="true" className="inline-block w-2 h-2 bg-orange-600" />
              <span className="font-default text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
                HIGHLIGHTS TERKINI
              </span>
            </div>
            <h2 className="font-default font-bold uppercase leading-[0.94] tracking-tight text-black" style={{
            fontSize: "clamp(2.25rem, 5.4vw, 4.75rem)"
          }}>
              BERITA{" "}
              <span className="relative inline-block">
                <span className="relative z-10 bg-orange-600 text-white px-3 py-1">
                  UTAMA
                </span>
              </span>{" "}
              NASIONAL
            </h2>
          </div>

          <div className={`md:col-span-5 md:text-right transition-all duration-500 ease-[cubic-bezier(0.2,0.8,0.2,1)] delay-100 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
            <div className="font-default font-bold text-black leading-none" style={{
            fontSize: "clamp(3rem, 6vw, 5rem)"
          }}>
              <span className="text-orange-600">{counterCurrent}</span>
              <span className="text-gray-400"> / {counterTotal}</span>
            </div>
            <p className="mt-3 font-default text-xs uppercase tracking-[0.12em] text-gray-500">
              Geser, scroll, atau gunakan tombol navigasi ↔
            </p>
          </div>
        </div>
      </div>

      <div aria-hidden="true" className="mt-12 md:mt-16 h-[14px] w-full" style={{
      backgroundImage: "repeating-linear-gradient(45deg, #ea580c 0 12px, #291c17 12px 24px)"
    }} />

      <div className="mt-10 md:mt-14">
        <div ref={scrollerRef} className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-6 px-[clamp(1rem,4vw,3rem)] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" tabIndex={0}>
          {highlights.map((item, i) => <article data-index={i} data-card key={i} className="group snap-start shrink-0 w-[280px] md:w-[420px] h-[480px] md:h-[540px] bg-white text-black relative border border-gray-200 rounded-lg flex flex-col shadow-md">
              <div aria-hidden="true" className="h-[3px] w-full" style={{
            backgroundImage: "repeating-linear-gradient(45deg, #291c17 0 4px, #4a3728 4px 8px)"
          }} />

              <div className="relative overflow-hidden h-[60%] w-full border-b border-gray-200">
                <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-220 ease-[cubic-bezier(0.2,0.8,0.2,1)] group-hover:scale-[1.03]" />
              </div>

              <div className="flex-1 flex flex-col p-5 md:p-6">
                <div className="font-default text-xs uppercase tracking-[0.12em] text-gray-500 mb-3">
                  <span aria-hidden="true" className="text-orange-600">▪</span>{" "}
                  {item.date}
                </div>
                <h3 className="font-default font-bold uppercase text-xl md:text-2xl leading-tight text-black mb-3 relative inline-block self-start">
                  {item.title}
                  <span aria-hidden="true" className="absolute -bottom-1 left-0 h-1 bg-orange-600 w-0 group-hover:w-full transition-all duration-300 ease-[cubic-bezier(0.2,0.8,0.2,1)]" />
                </h3>
                <p className="font-default text-sm md:text-base leading-relaxed text-gray-700 mb-4 flex-1">
                  {item.description}
                </p>
                <Link to="/NewsPage" className="inline-flex items-center gap-2 font-default text-xs font-semibold uppercase tracking-[0.12em] text-black self-start">
                  <span className="border-b-2 border-orange-600 pb-0.5 group-hover:border-b-4 transition-all duration-150">
                    BACA SELENGKAPNYA →
                  </span>
                </Link>
              </div>
            </article>)}
        </div>

        <div className="mx-auto max-w-[1360px] px-[clamp(1rem,4vw,3rem)] mt-8">
          <div className="flex items-center gap-4 md:gap-6">
            <div className="flex-1 relative h-px bg-gray-200">
              <div className="absolute top-0 left-0 h-px bg-orange-600 transition-all duration-300 ease-[cubic-bezier(0.2,0.8,0.2,1)]" style={{
              width: `${progressPercent}%`
            }} />
              <div aria-hidden="true" className="absolute -top-[3px] w-2 h-2 bg-orange-600 transition-all duration-300 ease-[cubic-bezier(0.2,0.8,0.2,1)]" style={{
              left: `calc(${progressPercent}% - 4px)`
            }} />
            </div>

            <div className="flex items-center gap-3">
              <Button onClick={() => scrollToCard("prev")} disabled={activeIndex === 0} aria-label="Berita sebelumnya" className="font-default text-xs font-bold uppercase tracking-[0.06em] bg-transparent text-black border border-black rounded-md px-4 py-3 h-auto hover:bg-black hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors duration-180">
                <ArrowLeft className="w-4 h-4" />
                <span className="hidden md:inline">SEBELUMNYA</span>
              </Button>
              <Button onClick={() => scrollToCard("next")} disabled={activeIndex === totalCards - 1} aria-label="Berita selanjutnya" className="font-default text-xs font-bold uppercase tracking-[0.06em] bg-orange-600 text-white rounded-md px-4 py-3 h-auto hover:bg-orange-700 disabled:opacity-40 disabled:cursor-not-allowed shadow-md">
                <span className="hidden md:inline">SELANJUTNYA</span>
                <ArrowRight className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}